import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
`

export const Menu = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 450px;
    padding: 16px;
    color: ${theme.colors.blue} !important;

    @media (max-width: 768px) { 
        width: 100%; 
        align-items: flex-start;
    }
`

export const MenuItem = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 8px;
    font-weight: bold;
    border-radius: 4px;
    border-bottom: 1px solid ${theme.colors.lightBlue};
    cursor: pointer;

    &:hover{
        background-color: ${theme.colors.gray};
    }
`
